import useQuery from '@/api/queries/useQuery';
import { usePartnerScoreGlobalFilter } from '@/components/partner';
import { ScoreData } from '@/pages/PartnerScore/components/PartnerScoreDataAvailability/PartnerScoreDataAvailabilityTypes/PartnerScoreDataAvailabilitytypes';
import { CubeQuery } from '@/types/cube';
import { toNumberOrNull, toStringOrNull } from '@/utils/cube';
import { CubeRawRow } from '@/utils/cube/mapper.type';
import { UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { PartnerScoreCacheKeys } from './cacheKeys';

const CUBE_NAME = 'partnerscore';

function usePartnerScoreDataAvailability({} = {}): UseQueryResult<ScoreData[], AxiosError> {
  const { globalFiltersWithoutHcpCountryCode, countries } = usePartnerScoreGlobalFilter();

  const query: CubeQuery = {
    dimensions: [
      `${CUBE_NAME}.quarter`,
      `${CUBE_NAME}.year`,
      `${CUBE_NAME}.country_code`,
      `${CUBE_NAME}.response_id`,
      `${CUBE_NAME}.survey_source`,
    ],
    filters: [
      {
        member: `${CUBE_NAME}.country_code`,
        operator: 'equals',
        values: countries,
      },

      globalFiltersWithoutHcpCountryCode,
    ],
    limit: 10000,
  };

  const isEnabled = !!countries.length;

  return useQuery<CubeRawRow[], AxiosError, ScoreData[]>({
    payload: query,
    options: {
      queryKey: [...PartnerScoreCacheKeys.partnerScoreDataAvailability(query)],
      select: data => {
        if (!data.length) return [];

        return data.map(availabilityItem => ({
          year: toNumberOrNull(availabilityItem[`${CUBE_NAME}.year`]),
          quarter: toNumberOrNull(availabilityItem[`${CUBE_NAME}.quarter`]),
          responseId: toStringOrNull(availabilityItem[`${CUBE_NAME}.response_id`]),
          country: toStringOrNull(availabilityItem[`${CUBE_NAME}.country_code`]),
          survey_source: toStringOrNull(availabilityItem[`${CUBE_NAME}.survey_source`]),
        }));
      },
      enabled: isEnabled,
    },
  });
}

export default usePartnerScoreDataAvailability;
